import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ParticipantResponse, ChatParticipantType, Message, User } from 'ng-chat';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { GET_CHAT_SUBJECTS, GET_CHAT_HISTORY, SEND_CHAT_MESSAGE } from './chat-constants';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root'
})
export class ChatService {

    chatList: Array<ParticipantResponse> = [];
    parentMessageIdMap = new Map();
    participantNameMap = new Map();
    selectedChatId = new BehaviorSubject<number>(0);
    unreadMsgMap = new Map();
    participantList = new BehaviorSubject<ParticipantResponse[]>([]);
    participantList$;

    newChat = new BehaviorSubject<User>(null);
    closeChat = new BehaviorSubject<any>(null);

    constructor(private http: HttpClient) {
        this.participantList$ = this.participantList.asObservable();
    }

    getChatSubjects(fileId, userId): Observable<ParticipantResponse[]> {
        return this.http.get(GET_CHAT_SUBJECTS + fileId + '/' + userId)
        /* return of({
            "code": "S0000",
            "message": "Total 3 records found",
            "result": [
                {
                "fromUser": 2,
                "userName": "Sanil",
                "unreadCount": 2,
                "latestDate": null,
                "parentMessageId": 17
                },
                {
                "fromUser": 3,
                "userName": "Jaseer",
                "unreadCount": 3,
                "latestDate": null,
                "parentMessageId": 20
                }
            ]
            })  */
        .pipe(map(res => {
            this.chatList = [];
            let subjects = res['result'];
            subjects.map(item => {
                let participantResponse = new ParticipantResponse();
                let user = {
                    participantType: ChatParticipantType.User,
                    id: item['fromUser'],
                    displayName: item['userName'],
                    avatar: item['avatar'],
                    status: 4
                }
                participantResponse.participant = user;
                participantResponse.metadata = {
                    totalUnreadMessages: item['unreadCount']
                }
                this.chatList.push(participantResponse);
                if (item['unreadCount'] > 0) {
                    this.countUnreadMsgs(item['parentMessageId'])
                }
                this.setParentMessageId(item['fromUser'], item['parentMessageId'])
                this.participantNameMap.set(item['fromUser'], item['userName']);

                this.participantList.next(this.chatList);
            });
            return this.chatList;
        }))
    }

    getChatHistory(chatId: number): Observable<Message[]> {
        let chatHistory: Array<Message> = [];
        const parentMessageId = this.parentMessageIdMap.get(chatId);
        if(!parentMessageId){
            return of(chatHistory);
        }
        
        /* return of({
            "code": "S0000",
            "message": "Total 2 records found",
            "result": [
                {
                    "messageId": 17,
                    "medfiId": 1,
                    "messageBody": "how are you",
                    "prevMessageId": null,
                    "fromUser": 2,
                    "userName": "sanil",
                    "createdTime": "22-08-2020 20:37"
                },{
                    "messageId": 18,
                    "medfiId": 1,
                    "messageBody": "hi",
                    "prevMessageId": 17,
                    "fromUser": 2,
                    "userName": "sanil",
                    "createdTime": "22-08-2020 20:38"
                },
                {
                    "messageId": 19,
                    "medfiId": 1,
                    "messageBody": "I am fine",
                    "prevMessageId": 17,
                    "fromUser": 1,
                    "userName": "Ranjeeth",
                    "createdTime": "22-08-2020 20:39"
                },
                {
                    "messageId": 20,
                    "medfiId": 1,
                    "messageBody": "How about you",
                    "prevMessageId": 17,
                    "fromUser": 1,
                    "userName": "Ranjeeth",
                    "createdTime": "22-08-2020 20:40"
                }
            ]
          }) */
        return this.http.get(GET_CHAT_HISTORY + parentMessageId)
        .pipe(map(res => {
            let history = res['result'];
            history.map(item => {
                let message = {
                    dateSent: moment(item['createdTime'], "DD-MM-YYYY HH:mm").toDate(),
                    fromId: item['fromUser'],
                    message: item['messageBody'],
                    toId: item['toUser'],
                    type: 1
                }
                chatHistory.push(message);
            });
            return chatHistory;
        }));
        
    }

    setParentMessageId(destinatoryId, parentMessageId) {
        this.parentMessageIdMap.set(destinatoryId, parentMessageId);
    }

    markAsRead(messageId, recipient) {
        // This will be handled on the server side whenever the chat is opened
        // if (('' + messageId).includes(SEPARATOR)) {    //Not needed for new messages
        //     let subjectId = messageId.split(SEPARATOR)[0];
        //     this.http.get(MARK_AS_READ_CHAT + fileId + '/' + recipient).subscribe(res => {
        //         this.unreadMsgMap.delete(messageId);
        //     });
        // }
    }

    sendMessage(payload: Message, fileId) {

        let prevMessageId = this.parentMessageIdMap.get(payload.toId); 

        let body = {
            'archiveYn': 'Y',
            'chatRecipient': {
                'isRead': 'N',
                'recipientName': this.participantNameMap.get(payload.toId),
                'toUser' : payload.toId
            },
            'fromUser': payload.fromId,
            'prevMessageId': prevMessageId,
            'medfiId': fileId,
            'messageBody': payload.message,
            'subject': 'string'
        }

        this.http.post(SEND_CHAT_MESSAGE, body).subscribe(res => {
            if (res['code'] === 0 && !prevMessageId) {   
                const newId = res['result'];
                this.setParentMessageId(payload.toId, newId);
                // let participant = {
                //     participantType: ChatParticipantType.User,
                //     id: newId,
                //     status: 4,
                //     avatar: null,
                //     displayName: this.newChat.value.displayName
                // };


                // let participantResponse: ParticipantResponse = new ParticipantResponse();
                // participantResponse.participant = participant;
                // participantResponse.metadata = {
                //     totalUnreadMessages: 0
                // }

                // this.participantList.next([participantResponse, ...this.participantList.value]);

                // let user = {
                //     participantType: ChatParticipantType.User,
                //     id: newId,
                //     displayName: this.newChat.value.displayName,
                //     avatar: null,
                //     status: 4
                // }

                // this.closeChat.next({ closeId: payload.toId, openId: user });



            }
        });
    }

    countUnreadMsgs(messageId) {
        let present = this.unreadMsgMap.has(messageId);
        //Increment only if there is no entry present for the message id
        if (!present) {
            this.unreadMsgMap.set(messageId, 1);
        }
    }

    messageReceived(messageId, participant) {
        this.countUnreadMsgs(messageId);
        if (this.participantList.value.filter(person => person.participant.id === messageId).length === 0) {
            this.participantList.next([participant, ...this.participantList.value]);
        }
    }

}
